import { IListingFavorite } from '../interfaces/listing-favorite';
import { Listing } from './listing';
import { ListingPoint } from './listing-point';
import { User } from './user';

export class ListingFavorite implements IListingFavorite {
  id?: number;
  userId: number;
  user?: User;
  listingId: number;
  listing?: Listing;
  mapPoint?: ListingPoint;

  constructor(data?: IListingFavorite) {
    if (data) {
      this.setData(data);
    }
  }

  setData(data: IListingFavorite): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }

    if (data.mapPoint) {
      this.mapPoint = new ListingPoint(data.mapPoint);
    }
  }
}
